define('views/content/customer_license',['require','backbone','marionette','text!templates/content/customer_license.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');


    var temp = require("text!templates/content/customer_license.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'customer-license-page',
        titleKey: 'license',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                aliasField: '#alias',
                extraDataContainer: '.extra-data-container',
                updateButton: '#update-button'
            };
        },

        events: {
            'click @ui.updateButton': 'updateButtonClicked'
        },

        templateHelpers: function(){
            return {
                registrationNumberEntry: this.model.get('extra_data').filter(function(x) {
                    return x.key == 'registration_number';
                })[0],
                macIdEntry: this.model.get('extra_data').filter(function(x) {
                    return x.key == 'mac_id';
                })[0]
            };
        },

        updateButtonClicked: function () {
            var _this = this;

            _this._setExtraData(true);
            _this.ui.updateButton.addClass('loading');

            this.model.set('alias', this.ui.aliasField.val());

            this.model.save(null, {
                success: function (model, response, options) {
                    _this.ui.updateButton.removeClass('loading');

                    App.utils.showMessage('success', App.polyglot.t('update_success'));
                },
                error: function (model, response, options) {
                    _this.ui.updateButton.removeClass('loading');

                    // Show error messages
                    if (response.responseJSON.errors) {
                        for (var i=0; i<response.responseJSON.errors.length; i++) {
                            App.utils.showMessage('error', response.responseJSON.errors[i].message);
                        }
                    }
                }
            });
        },

        _setExtraData: function (ignoreEmtpy) {
            var extraData = [];

            this.ui.extraDataContainer.find('input').each(function () {
                if (!ignoreEmtpy || $(this).val()) {
                    extraData.push({
                        key: $(this).attr('data-key'),
                        value: $(this).val()
                    });
                }
            });

            this.model.set('extra_data', extraData);
        }

    });
});
